import { validatePasswordPair } from '../../_shared/domain/password.validation';
import type { ResetPasswordDraft } from './reset-password.model';

export { MIN_PASSWORD_LENGTH } from '../../_shared/domain/password.validation';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof ResetPasswordDraft, string>>;

/**
 * Pure business validation for the reset-password draft. Delegates to the
 * auth-wide password-pair rules (`_shared`): the minimum-length rule reports
 * before the mismatch, so a too-short password never also flags the
 * confirmation.
 */
export function validateDraft(draft: ResetPasswordDraft): ValidationErrors {
  return validatePasswordPair(draft);
}
